import React from "react";
import { Toaster as SonnerToaster } from "sonner";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import { GlobalStyles } from "@mui/material";
const Toast = ({ position = "top-center", richColors = true, ...rest }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyles, { styles: (theme) => `
                    :where([data-sonner-toaster]) {
                      --width: 454px !important;
                    }
                    :where([data-sonner-toast]) :where([data-content]) {
                      margin-right: auto;
                    }
                    [data-sonner-toast][data-styled=true] [data-button] {
                        --normal-text: transparent;
                        --normal-bg: ${theme.palette.primary.main};
                        text-transform: capitalize;
                        font-weight: ${theme.typography.fontWeightMedium};
                        font-family: ${theme.typography.fontFamily};
                        font-size: ${theme.typography.fontSize}px !important;
                        --toast-button-margin-start: 0;
                    }
                    [data-sonner-toaster][data-theme][data-theme=light] {
                      --toast-icon-margin-end: ${theme.spacing(1)};
                      font-family: ${theme.typography.fontFamily};
                      --border-radius: ${theme.shape.borderRadius}px;
                      
                      --normal-bg: ${theme.palette.background.default};
                      --normal-border: ${theme.palette.background.paper};
                      --normal-text: ${theme.palette.text.primary};
                    
                      // TODO: replace colors from palette
                      --success-bg: #F6F6E5;
                      --success-border: #DAD646;
                      --success-text: #424200;
                      
                      --error-bg: #F7E7E4;
                      --error-border: #E2542D;
                      --error-text: #440C00;

                      --warning-bg: #FDF4E4;
                      --warning-border: #E7AF7D;
                      --warning-text: #5C3900;

                      --info-bg: #EBEFF6;
                      --info-border: #5F9DE7;
                      --info-text: "#0C2C48";
                    }
                    // container text
                    :where([data-sonner-toast]) :where([data-title]) {
                      font-weight: ${theme.typography.fontWeightRegular} !important;
                      font-size: ${theme.typography.fontSize}px !important;
                    }
                    // toaster container
                    :where([data-sonner-toast][data-styled="true"]) {
                      min-height: 53px !important;
                      padding: ${theme.spacing(1)} ${theme.spacing(2)} !important;
                    }
                    // close button 
                    [data-sonner-toast] [data-close-button] {
                      position: static;
                      order: 3;
                      border: 0;
                      border-radius: 0;
                      transform: none;
                    }
                  ` }),
        React.createElement(SonnerToaster, { ...rest, position: position, richColors: richColors, toastOptions: {
                className: "sonner-toast",
            }, icons: {
                success: React.createElement(CheckCircleIcon, { sx: { color: "success.main" } }),
                info: React.createElement(InfoIcon, { sx: { color: "info.main" } }),
                error: React.createElement(ErrorIcon, { sx: { color: "error.main" } }),
                warning: React.createElement(InfoIcon, { sx: { color: "warning.main", transform: "rotate(180deg)" } }),
                close: React.createElement(CloseIcon, { fontSize: "small", sx: { color: "inherit" } }),
            } })));
};
export default Toast;
//# sourceMappingURL=Toast.js.map